import { useParams, Navigate } from "react-router-dom";
import { FUNC_GROUPS } from "@/data/useCases";
import UseCaseGroup from "@/pages/UseCaseGroup";
import UseCaseDetail from "@/pages/UseCaseDetail";

/**
 * Route dispatcher for `/use-cases/:id`.
 *   - If `id` is one of the 4 functional groups → render the group page.
 *   - Otherwise → render the individual agent detail page.
 *   - If neither matches → redirect to the first group.
 */
const GROUP_IDS = new Set(FUNC_GROUPS.map((g) => g.id));

export default function UseCasesRouter() {
    const { id } = useParams();
    if (!id) return <Navigate to="/use-cases/listen" replace />;
    return GROUP_IDS.has(id) ? <UseCaseGroup /> : <UseCaseDetail />;
}
